module.exports = __webpack_public_path__ + "static/media/cspire_logo_SVG.ad8413c2.svg";